<template>
  <div class="section">
    <div class="container custom-container">
      <div class="modal" v-bind:class="{'is-active': showingDeleteModal}">
        <div class="modal-background" />
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Confirm</p>
            <button class="delete" aria-label="close" v-on:click="toggleDeleteConfirmationModal" />
          </header>
          <section class="modal-card-body">Are you sure you want to delete this simulation?</section>
          <footer class="modal-card-foot">
            <button class="button is-danger" v-on:click="deleteSimulation">Delete</button>
            <button class="button" v-on:click="toggleDeleteConfirmationModal">Cancel</button>
          </footer>
        </div>
      </div>
      <h1 class="title">
        <Loader v-bind:isLoading="isLoading" />&nbsp;Activity
      </h1>
      <table class="table is-striped is-fullwidth">
        <thead>
          <tr>
            <th class="sortable" @click="sortedBy('title')">Title <SortedIcon v-bind:direction="currentSortDir" v-bind:currentSort="currentSort" thisSort="title" /></th>
            <th class="sortable" @click="sortedBy('created_at')">Created <SortedIcon v-bind:direction="currentSortDir" v-bind:currentSort="currentSort" thisSort="created_at" /></th>
            <th class="sortable" @click="sortedBy('started_at')">Started <SortedIcon v-bind:direction="currentSortDir" v-bind:currentSort="currentSort" thisSort="started_at" /></th>
            <th class="sortable" @click="sortedBy('finished_at')">Finished <SortedIcon v-bind:direction="currentSortDir" v-bind:currentSort="currentSort" thisSort="finished_at" /></th>
            <th class="sortable" @click="sortedBy('status')">Status <SortedIcon v-bind:direction="currentSortDir" v-bind:currentSort="currentSort" thisSort="status" /></th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="sim in sortedActivity"
            :key="sim.id"
            v-bind:class="{ 'has-text-grey-light': sim.isLoading}"
          >
            <td>{{sim.title}}</td>
            <td>{{sim.created_at | formatDate }}</td>
            <td>{{sim.started_at | formatDate }}</td>
            <td>{{sim.finished_at | formatDate }}</td>
            <td>{{ statusText(sim.status) }}</td>
            <td>
              <div class="field is-grouped">
                <p class="control" v-if="sim.status > 1">
                  <router-link
                    :to="{name: 'result', params: { id: sim.id}}"
                    class="button is-primary"
                  >
                    <span class="icon">
                      <font-awesome-icon icon="eye" />
                    </span>
                  </router-link>
                </p>
                <p class="control">
                  <a class="button is-danger" v-on:click="toggleDeleteConfirmationModal(sim.id)">
                    <span class="icon">
                      <font-awesome-icon icon="trash-alt" />
                    </span>
                  </a>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Loader from '@/components/Loader.vue';
import SortedIcon from '@/components/SortedIcon.vue';
import apiCall from '../lib/remote-calls';

export default {
  components: {
    Loader,
    SortedIcon,
  },
  data() {
    return {
      isLoading: false,
      showingDeleteModal: false,
      deleteModalSimulationId: null,
      statusNames: ['Pending', 'Running', 'Completed', '', 'Error'],
      activity: [],
      currentSort: 'created_at',
      currentSortDir: 'desc',
    };
  },
  computed: {
    sortedActivity() {
      return this.activity.slice().sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') modifier = -1;
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
        return 0;
      });
    },
  },
  methods: {
    sortedBy(s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
    statusText(statusCode) {
      return this.statusNames[statusCode];
    },
    async requestActivity() {
      this.isLoading = true;
      try {
        const response = await apiCall('GET', 'simulations');
        this.activity = response.data.simulations;
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
    toggleDeleteConfirmationModal(simulationId = null) {
      if (simulationId !== null) {
        this.deleteModalSimulationId = simulationId;
      }
      this.showingDeleteModal = !this.showingDeleteModal;
    },
    async deleteSimulation() {
      const databaseId = this.deleteModalSimulationId;
      this.toggleDeleteConfirmationModal(null);

      let arrayIndex = null;
      const remainingSimulations = this.activity.filter((el, index) => {
        if (el.id === databaseId) {
          arrayIndex = index;
          return false;
        }
        return true;
      });

      try {
        this.activity[arrayIndex].isLoading = true; // for presentation purposes
        await apiCall('DELETE', `simulations/${databaseId}`);
      } catch (error) {
        this.activity[arrayIndex].isLoading = false;
        console.error(error);
      }
      this.activity = remainingSimulations;
    },
  },
  mounted() {
    this.requestActivity();
  },
};
</script>
<style scoped>
  th.sortable {
    cursor: pointer;
  }
</style>
